import graphql__9206b422439be9c50e07 from "./__generated__/AppVisibilitySectionQuery.graphql.ts";import { graphql } from 'babel-plugin-relay/macro'
import { useLazyLoadQuery } from 'react-relay/hooks'
import { useAppManagementContext } from 'scenes/appManagement/context'

import { AppVisibilitySectionQuery } from './__generated__/AppVisibilitySectionQuery.graphql'
import AppVisibilityForm from './AppVisibilityForm'

const query = graphql__9206b422439be9c50e07

export default function AppVisibilitySection() {
  const { appId } = useAppManagementContext()
  const { viewer } = useLazyLoadQuery<AppVisibilitySectionQuery>(query, {
    appId,
  })

  return (
    <div>
      <h3 className="text-lg font-medium leading-6 text-foreground-normal">
        Change app visibility
      </h3>
      <p className="mt-1 text-base text-foreground-subtle">
        Change which role(s) in the org can see your app
      </p>

      <AppVisibilityForm
        appId={appId}
        appVisibility={viewer.appById?.visibility || 'EVERYONE'}
      />
    </div>
  )
}
